import { render, staticRenderFns } from "./JobOpening.vue?vue&type=template&id=5a1bb188&scoped=true"
import script from "./JobOpening.vue?vue&type=script&lang=js"
export * from "./JobOpening.vue?vue&type=script&lang=js"
import style0 from "./JobOpening.vue?vue&type=style&index=0&id=5a1bb188&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1bb188",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a1bb188')) {
      api.createRecord('5a1bb188', component.options)
    } else {
      api.reload('5a1bb188', component.options)
    }
    module.hot.accept("./JobOpening.vue?vue&type=template&id=5a1bb188&scoped=true", function () {
      api.rerender('5a1bb188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/front/Candidate/SignIn/Progress/JobOpening.vue"
export default component.exports